(function($) {
    
  'use strict';

 var owlBanner = $('.banners').owlCarousel({
      loop:true,
      interval: 2000,
      pause: "false",
      smartSpeed: 1000,
      items:1,
      dots: true,
      autoplay:false,
      autoplayTimeout:5000,
      autoplayHoverPause:false,
      nav: false,
      margin: 0,
      responsiveClass:true,
      
    });


}(jQuery));